// LIBS
import React from 'react'

// COMPONENTS
import MetaData from '../../components/meta-data'

// INTERFACE
export const query = graphql`
  query PageJsonQuery($slug: String!) {
    pageJson(slug: { eq: $slug}) {
      slug
      title
      content
      keywords
      metaDescription
      imageHeader {
        fields {
          file {
            url
          }
        }
      }
    }
  }
`;

export default ({data, location}) => {
  if(!data.pageJson)
    return <div className='ut-oh'> </div>
  let {title, content, metaDescription, slug} = data.pageJson
   
  return (
    <div itemScope itemType="http://schema.org/WebPage" className='legacyPage'> 
      <MetaData data={data.pageJson} />
      <div className='custom_pages'>
        <div itemType='mainContentOfPage' className='markdown' dangerouslySetInnerHTML={{__html: content}} />
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/templates/page/index.js